import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  CategoryInterface,
  selectCategoryById,
  setEditId,
  setEditError
} from "../../../store/sticker_maker/categoriesSlice";
import {
  updateCategory,
  fetchCategory,
  fetchCategories,
  destroyImage
} from "../../../actions/sticker_maker/categoriesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch  = useAppDispatch();
  const id: any   = useAppSelector(state => state.stickerMaker.categories.editId);
  const category  = useAppSelector((state) => selectCategoryById(state, id));
  const error     = useAppSelector(state => state.stickerMaker.categories.editError);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategory(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: CategoryInterface) {
    handleSave(data).catch(console.error);
  }

  function getLocaleRules() {
    const localeRules: any = {};

    if (category) {
      category.empty_locales.forEach(key => localeRules[key] = { blank: false });
    }

    return localeRules;
  }

  async function handleSave(data: object) {
    const rules         = { name_translations: getLocaleRules() };
    const formData: any = objToFormData(data, rules);
    const resultAction  = await dispatch(updateCategory({ id, data: formData  }));

    if (updateCategory.fulfilled.match(resultAction)) {
      dispatch(fetchCategories({ target: category?.target }));
      onClose();
    }
  }

  function onClickFileDestroy() {
    dispatch(destroyImage({ id }));
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-category'>
        <h6 className="v-content-label">Edit Category</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        {
          category &&
            <Form
              params={category}
              onFinish={onFinish}
              onClickFileDestroy={onClickFileDestroy}
            />
        }
      </div>
    </DrawerRight>
  )
}

export default Edit;
